import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import CollectionGrid from 'components/CollectionGrid';
import { fetchCollectionBySlug } from 'store/actions/collectionActions';
import { Container, Stack, Typography } from '@mui/material';

const PublicCollection = () => {
  const { slug } = useParams<{ slug: string }>();
  const dispatch = useDispatch();
  const { activeCollection } = useSelector((state: any) => state.collection);

  useEffect(() => {
    dispatch({ type: fetchCollectionBySlug.request, payload: { slug } });
  }, [dispatch, slug]);

  return (
    <Container maxWidth='lg' sx={{ mt: 4 }}>
      <Stack spacing={2} sx={{ flex: '1 1 auto', alignItems: 'center' }}>
        <Typography variant='h4' align='center'>
          {activeCollection.name}
        </Typography>
        {activeCollection.description && (
          <Typography variant='body1' align='center'>
            {activeCollection.description}
          </Typography>
        )}
      </Stack>
      <CollectionGrid publicView={true} />
    </Container>
  );
};

export default PublicCollection;
